<template>
    <div class=" shadow-sm p-3 mb-3">
        <div class="text-white text-center" :class="delivery.validated ? 'bg-success' : 'bg-primary'">
            <h5> Livraison Nº : <span class="fw-bold">{{ reference }}</span></h5>
        </div>
        <div class="">
            <!-- <vue-action-buttons :buttons="buttons" /> -->


            

            <!-- Delivery Info -->
            <div class="row mt-3">
                <div class="col-md-6">
                    <ul class="list-unstyled">
                        <li>État :<strong class="fw-bold">{{ delivery.deliveryFullName != null ? "Livré" : "Non Livré"
                                }}</strong> </li>
                        <li>Livré par :<strong class="fw-bold"> {{ delivery.deliveryFullName }}</strong> </li>
                        <li>Entreé le :<strong class="fw-bold"> {{ delivery.startChargeDatetime }}</strong> </li>
                        <li>Livré le :<strong class="fw-bold"> {{ delivery.deliveryDateTime }}</strong> </li>
                        <li> Véhicule :<strong class="fw-bold"> {{ delivery.vehicleFullName }}</strong> </li>
                        <li> Poid B :<strong class="fw-bold"> {{ delivery.grossWeight }}</strong> </li>
                        <li> Poid T :<strong class="fw-bold"> {{ delivery.tareWeight }}</strong> </li>
                        <li> Remarque :<strong class="fw-bold"> {{ delivery.remark }}</strong> </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        delivery: {
            type: Object,
            required: true,
        },
        reference: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            

        }
    },
    methods: {
        
    },
};
</script>

<style scoped>
.card {
    border-radius: 0.75rem;
}
</style>
